export default "__VITE_ASSET__1WgKjwrU__"